var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPencil = function SvgPencil(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.47 2.458a4.294 4.294 0 1 1 6.073 6.072L7.537 22.536a.9.9 0 0 1-.637.264H2.1a.9.9 0 0 1-.9-.9v-4.8a.9.9 0 0 1 .264-.636zM18.506 3c-.661 0-1.296.263-1.764.73l-.469.47L19.8 7.727l.47-.47A2.494 2.494 0 0 0 18.506 3m.021 6L15 5.473l-12 12V21h3.527z",
    clipRule: "evenodd"
  })));
};
export default SvgPencil;